/* 
Copyright (c) Karsten Jeske and John Firth
This source code is licensed under the proprietary license found in the
LICENSE file in the root directory of this source tree.
*/

const NotFound = () => {
  return (
    <div className="pt-1 pb-3 container-fluid">
      <h3>404 - Page Not Found</h3>
      <p className="mt-4">The page you&apos;re looking for doesn&apos;t exist.</p>
    </div>
  )
}

export default NotFound
